module.exports = {"150626100":"嘎鲁图镇","150626101":"乌审召镇","150626102":"图克镇","150626103":"乌兰陶勒盖镇","150626104":"无定河镇","150626200":"苏力德苏木乡","150626402":"纳林河化工项目区","150626403":"图克化工项目区","150626405":"乌审召生态化工项目区","150626406":"苏里格经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150626.json
// module id = 397
// module chunks = 0